import { useEffect } from 'react';
import { HIDE_COOKIE_BANNER_STORAGE_KEY } from '../CookiePoliciesBanner/CookiePoliciesBanner';
import './InterhomeRetryPayment.scss';

function InterhomeRetryPayment() {

  useEffect(() => {
    sessionStorage.setItem(HIDE_COOKIE_BANNER_STORAGE_KEY, 'false');
  }, []);

  return (
    <div className="interhome-retry-payment">
      <div className="message">
        <div className="title">Oops, something went wrong!!</div>
        <div className="text">please press the button to retry...</div>
      </div>
    </div>
  );
}
export default InterhomeRetryPayment;
